export const title = 'Cost centers';

export const add_cost_center_button = 'Add a cost center';
export const cost_center_empty_cta_title =
  'Keep track of department or team expenses through cost centers';
export const cost_center_empty_cta_subtitle =
  'Add a cost center to tag it to departments or individual employees';

export const search_place_holder_text = 'Search for cost center name';

export const add_title = 'Add a cost center';
export const edit_title = 'Edit cost center';

export const deleteDialogContent =
  'Deleting this cost center might affect the reports and allowances of employees linked to it. Delete anyway?';

export const initialValues = {
  name: ''
};

export enum Actions {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete'
}

export enum ButtonText {
  Save = 'Save',
  SaveAndNext = 'Save and add another'
}
